"use client";
import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { useTranslation } from "react-i18next";
import customURLSearchParams from "services/CustomURLSearchParams";
import { useAtom } from "jotai";
import {
  filtersAtomObject,
  originalFiltersAtomObject,
  searchBarFiltersAtomObject,
} from "../../state";
import SearchBarPlaces from "components/SearchBar/SearchBarPlaces";
import "./SearchBar.scss";

const SearchBar = ({ locationFilterValue, keywordFilterValue }) => {
  const [filters, setFilters] = useAtom(filtersAtomObject);
  const [originalFilters] = useAtom(originalFiltersAtomObject);

  const [searchBarFilters, setSearchBarFilters] = useAtom(
    searchBarFiltersAtomObject
  );
  const [selectedJobType, setSelectedJobType] = useState("any");

  const [userInteracted, setUserInteracted] = useState(false)

  const { t } = useTranslation();

  const preventSubmit = (e) => {
    e.preventDefault();
  };

  const updateJobTypes = (value) => {
    var splitValue = value.split(",");
    let newArray = originalFilters.jobTypes?.filter((x) => {
      return x.key === splitValue[0];
    });

    setSearchBarFilters({
      ...searchBarFilters,
      jobTypes: newArray,
    });
    setSelectedJobType(newArray?.length > 0 ? newArray[0].key : "any");
  };

  const handleChange = (address) => {
    setSearchBarFilters({
      ...searchBarFilters,
      locationSearchTerm: address,
    });
  };

  const handleSelect = async (address) => {
    setSearchBarFilters({
      ...searchBarFilters,
      location: address,
      locationSearchTerm: address,
    });
  };

  const handleLocationInteract = () => {
    setUserInteracted(true);
  };

  // Function to get query parameters from the URL
  const getQueryParams = () => {
    const params = customURLSearchParams();
    return {
      queryString: params.get("keyword") || "",
      location: params.get("location") || "",
      distance: params.get("distance") || 10,
      jobTypes: params.get("type") || "",
    };
  };

  useEffect(() => {
    const queryParams = getQueryParams();

    setFilters({
      queryString: queryParams.queryString  || keywordFilterValue,
      location: queryParams.location,
      distance: queryParams.distance,
    });

    setSearchBarFilters({
      keyword: queryParams.queryString || keywordFilterValue,
      location: queryParams.location,
      locationSearchTerm: queryParams.location,
      distance: queryParams.distance,
      jobTypes: queryParams.type,
    })
  }, []);

  useEffect(() => {
    if (filters.jobTypes && filters.jobTypes.length > 0) {
      setSelectedJobType(filters.jobTypes[0].key);
    } else {
      setSelectedJobType("any");
    }
  }, [filters]);

  return (

    <div className="vsm-search-bar">
      <div className="bg">
        <div className="component-wrapper">
          <div className="vsm-body">
            <Container>
              <Row>
                <Col>
                  <div className="content align-center">
                    <div className="search-bar">
                      <Row>
                        <Col>
                          <div className="form-holder">
                            <Form onSubmit={preventSubmit}>
                              <Row>
                                <Col>
                                  <div className="element text form-group">
                                    <Form.Label className="hidden">
                                      {t("keyword")}
                                    </Form.Label>
                                    <div className="field">
                                      <InputGroup>
                                        <Form.Control
                                          type="text"
                                          value={searchBarFilters.keyword || ""}
                                          onChange={(e) =>
                                            setSearchBarFilters({
                                              ...searchBarFilters,
                                              keyword: e.target.value,
                                            })
                                          }
                                          placeholder={t("keyword") + "..."}
                                        />
                                      </InputGroup>
                                    </div>
                                  </div>
                                </Col>
                                <Col>
                                  <InputGroup>
                                    <div className="element text form-group">
                                      <Form.Label className="hidden">
                                        {t("location")}
                                      </Form.Label>
                                      <div className="field">

                                        {!locationFilterValue &&
                                          !userInteracted && (
                                            <div className="autocomplete-location location-radius">
                                              <input type="text"
                                                placeholder="Search Locations..."
                                                className="location-search-input"
                                                onFocus={() =>
                                                  handleLocationInteract()
                                                }
                                                onMouseEnter={() =>
                                                  handleLocationInteract()
                                                }
                                              ></input>
                                            </div>
                                          )}
                                        {!locationFilterValue &&
                                          userInteracted && (
                                            <SearchBarPlaces
                                              handleChange={handleChange}
                                              handleSelect={handleSelect}
                                              searchBarFilters={searchBarFilters} >
                                            </SearchBarPlaces>
                                          )}
                                        {locationFilterValue && (
                                          <div className="autocomplete-location">
                                            <Form.Control
                                              type="text"
                                              value={locationFilterValue}
                                              disabled=""
                                            />
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                    {searchBarFilters?.location && (
                                      <div
                                        className={"element select form-group active"}
                                      >
                                        <Form.Label className="hidden">
                                          {t("radius")}
                                        </Form.Label>
                                        <div className="field">
                                          <Form.Control
                                            as="select"
                                            value={searchBarFilters?.distance || 10}
                                            onChange={(e) =>
                                              setSearchBarFilters({
                                                ...searchBarFilters,
                                                distance: e.target.value
                                              })
                                            }
                                          >
                                            <option value="0">
                                              0 {t("miles")}
                                            </option>
                                            <option value="5">
                                              5 {t("miles")}
                                            </option>
                                            <option value="10">
                                              10 {t("miles")}
                                            </option>
                                            <option value="20">
                                              20 {t("miles")}
                                            </option>
                                            <option value="30">
                                              30 {t("miles")}
                                            </option>
                                          </Form.Control>
                                        </div>
                                      </div>
                                    )}

                                  </InputGroup>
                                </Col>
                                
                                  {originalFilters.jobTypes &&
                                    originalFilters.jobTypes.filter(
                                      (x) => x.key !== "Unspecified"
                                    ).length > 0 && (
                                      <Col>
                                      <div className="element select">
                                        <div className="field">
                                          <Form.Control
                                            as="select"
                                            className="form-control"
                                            value={selectedJobType}
                                            onChange={(e) =>
                                              updateJobTypes(e.target.value)
                                            }
                                          >
                                            <option key="any" value="any">
                                              {t("any_job_type")}
                                            </option>
                                            {originalFilters?.jobTypes
                                              ?.filter(
                                                (x) => x.key !== "Unspecified"
                                              )
                                              .map((jobTypes) => (
                                                <option
                                                  key={jobTypes.value}
                                                  value={jobTypes.key}
                                                >
                                                  {jobTypes.display}
                                                </option>
                                              ))}
                                          </Form.Control>
                                        </div>
                                      </div>
                                      </Col>
                                    )}
                                
                                <Col xs="auto">
                                  <div className="element submit form-group">
                                    <button
                                      className="btn"
                                      type="submit"
                                      onClick={() => {
                                        setFilters({
                                          ...filters,
                                          queryString: searchBarFilters.keyword,
                                          jobTypes: searchBarFilters.jobTypes,
                                          location: searchBarFilters.location,
                                          distance: searchBarFilters.distance || 10,
                                        });
                                      }}
                                    >
                                      <span>{t("search")}</span>
                                    </button>
                                  </div>
                                </Col>
                              </Row>
                            </Form>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </div>
    </div>

  );
};

export default SearchBar;
